import * as React from "react";
import { IZLoginModule } from "../../../../modules/zcommon";
import  ListaFrecuente  from "../components/frecuentes/lista-frecuente/ListaFrecuente.comp";
import ListaPreferidos from "../components/preferidos/lista-preferidos/ListaPreferidos.comp";
import "./sidebar.style.css";

export interface ConnectedState {
  zLoginModule: IZLoginModule;
}

export interface OwnProps {
  onToggleSidebar?: () => void;
  isSidebarCollapsed?: boolean;
}

export const SidebarComp: React.FC <ConnectedState & OwnProps> = (props) => {

  const collapsed = props.isSidebarCollapsed === true;

  // Todo: connect to CM_Salir to perform logout instead of cleaning
  const onLogoutClick = () => {
    if (!window.confirm("¿Está seguro que desea cerrar sesión?")) {
      return;
    }
    try {
      sessionStorage.clear();
    } finally {
      window.location.replace(window.location.pathname);
    }
  };

  return (
    <>
    <aside className={collapsed ? "sidebar sidebar-collapsed" : "sidebar"}>
      <div className="sidebar-header">
        {props.onToggleSidebar && (
          <button
            type="button"
            className="sidebar-toggle-btn"
            aria-label={collapsed ? "Expandir sidebar" : "Colapsar sidebar"}
            onClick={props.onToggleSidebar}
          >
            <svg
              className="sidebar-toggle-icon"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              aria-hidden="true"
              focusable="false"
            >
              <rect x="2" y="2" width="14" height="14" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
              <line x1="6" y1="2" x2="6" y2="16" stroke="currentColor" strokeWidth="1.6" />
            </svg>
          </button>
        )}
      </div>

      {!collapsed && (
        <>
          <div className="sidebar-navbar">
            <div>
              <ListaPreferidos
                listaPreferidos={props.zLoginModule.zAplList.opcionesPreferidas}
                zLoginModule={props.zLoginModule}
              />
            </div>
            <hr className="divider-sidebar" />
            <div>
              <ListaFrecuente
                listaFrecuentes={props.zLoginModule.zAplList.opcionesFrecuentes}
                zLoginModule={props.zLoginModule}
              />
            </div>
          </div>
        </>
      )}

      <div className="sidebar-footer">
        <button
          type="button"
          className="sidebar-logout-btn"
          onClick={onLogoutClick}
          title="Cerrar sesión"
        >
          <span className="glyphicon glyphicon-log-out sidebar-logout-icon" aria-hidden="true" />
          {!collapsed && " Cerrar sesión"}
        </button>
      </div>
    </aside>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/portal/components/sidebar/sidebar/Sidebar.comp.tsx